(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2307],{

/***/ 9213:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(7294),__webpack_require__(6883)):0}(this,(function(e,t){"use strict";function n(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var r=n(t);function u(e){return e.concat().sort((function(e,t){return e.name>t.name?1:-1})).map((function(e){return e.options}))}function o(t,n){void 0===t&&(t={}),void 0===n&&(n=[]);var f=e.useRef(r.default.optionsHandler()),a=e.useRef(t),i=e.useRef(n),c=e.useState(),l=c[0],d=c[1],s=e.useState(),p=s[0],m=s[1],b=e.useCallback((function(){l&&l.reInit(a.current,i.current)}),[l]);return e.useEffect((function(){if("undefined"!=typeof window&&window.document&&window.document.createElement&&p){r.default.globalOptions=o.globalOptions;var e=r.default(p,a.current,i.current);return d(e),function(){return e.destroy()}}d(void 0)}),[p,d]),e.useEffect((function(){f.current.areEqual(a.current,t)||(a.current=t,b())}),[t,b]),e.useEffect((function(){(function(e,t){if(e.length!==t.length)return!1;var n=r.default.optionsHandler().areEqual,o=u(e),f=u(t);return o.every((function(e,t){var r=f[t];return n(e,r)}))})(i.current,n)||(i.current=n,b())}),[n,b]),[m,l]}return o.globalOptions=void 0,o}));


/***/ }),

/***/ 6883:
/***/ (function(module) {

!function(n,t){ true?module.exports=t():0}(this,(function(){"use strict";function n(n){return"number"==typeof n}function t(n){return"[object Object]"===Object.prototype.toString.call(n)}function e(n){return t(n)||function(n){return Array.isArray(n)}(n)}function r(n){return Math.abs(n)}function o(n){return n?n/r(n):0}function i(n,t){return r(n-t)}function u(n){return f(n).map(Number)}function c(n){return n[a(n)]}function a(n){return Math.max(0,n.length-1)}function f(n){return Object.keys(n)}function s(n,e){return[n,e].reduce((function(n,e){return f(e).forEach((function(r){var o=n[r],i=e[r],u=t(o)&&t(i);n[r]=u?s(o,i):i})),n}),{})}function d(n,t){var r=f(n),o=f(t);return r.length===o.length&&r.every((function(r){var o=n[r],i=t[r];return"function"==typeof o?"".concat(o)==="".concat(i):e(o)&&e(i)?d(o,i):o===i}))}function l(t,e){var r={start:function(){return 0},center:function(n){return o(n)/2},end:o};function o(n){return e-n}return{measure:function(o){return n(t)?e*Number(t):r[t](o)}}}function p(n,t){var e=r(n-t);function o(t){return t<n}function i(n){return n>t}function u(n){return o(n)||i(n)}return{length:e,max:t,min:n,constrain:function(e){return u(e)?o(e)?n:t:e},reachedAny:u,reachedMax:i,reachedMin:o,removeOffset:function(n){return e?n-e*Math.ceil((n-t)/e):n}}}function v(n,t,e){var o=p(0,n),i=o.min,u=o.constrain,c=n+1,a=f(t);function f(n){return e?r((c+n)%c):u(n)}function s(){return a}function d(n){return a=f(n),l}var l={add:function(n){return d(s()+n)},clone:function(){return v(n,s(),e)},get:s,set:d,min:i,max:n};return l}function m(){var n=[];var t={add:function(e,r,o,i){return void 0===i&&(i=!1),e.addEventListener(r,o,i),n.push((function(){return e.removeEventListener(r,o,i)})),t},removeAll:function(){return n=n.filter((function(n){return n()})),t}};return t}function g(t){var e=t;function r(n){return e/=n,i}function o(t){return n(t)?t:t.get()}var i={add:function(n){return e+=o(n),i},divide:r,get:function(){return e},multiply:function(n){return e*=n,i},normalize:function(){return 0!==e&&r(e),i},set:function(n){return e=o(n),i},subtract:function(n){return e-=o(n),i}};return i}function x(n,t,e,u,c,a,f,s,d,l,p,v,x,h,y,S){var b=n.cross,w=["INPUT","SELECT","TEXTAREA"],E=g(0),A=m(),M=m(),T=x.measure(20),O={mouse:300,touch:400},B={mouse:500,touch:600},P=y?5:16,k=0,I=0,z=!1,D=!1,L=!1,N=!1;function C(n){if(!(N="mousedown"===n.type)||0===n.button){var t,r,o=i(u.get(),a.get())>=2,f=N||!o,s=(t=n.target,r=t.nodeName||"",!(w.indexOf(r)>-1)),l=o||N&&s;z=!0,c.pointerDown(n),E.set(u),u.set(a),d.useBaseMass().useSpeed(80),function(){var n=N?document:e;M.add(n,"touchmove",V).add(n,"touchend",H).add(n,"mousemove",V).add(n,"mouseup",H)}(),k=c.readPoint(n),I=c.readPoint(n,b),v.emit("pointerDown"),f&&(L=!1),l&&n.preventDefault()}}function V(n){if(!D&&!N){if(!n.cancelable)return H(n);var e=c.readPoint(n),r=c.readPoint(n,b),o=i(e,k),a=i(r,I);if(!(D=o>a)&&!L)return H(n)}var s=c.pointerMove(n);!L&&s&&(L=!0),f.start(),u.add(t.apply(s)),n.preventDefault()}function H(n){var e=l.byDistance(0,!1).index!==p.get(),a=c.pointerUp(n)*(y?B:O)[N?"mouse":"touch"],f=function(n,t){var e=p.clone().add(-1*o(n)),i=e.get()===p.min||e.get()===p.max,u=l.byDistance(n,!y).distance;return y||r(n)<T?u:!h&&i?.4*u:S&&t?.5*u:l.byIndex(e.get(),0).distance}(t.apply(a),e),m=function(n,t){if(0===n||0===t)return 0;if(r(n)<=r(t))return 0;var e=i(r(n),r(t));return r(e/n)}(a,f),g=i(u.get(),E.get())>=.5,x=e&&m>.75,b=r(a)<T,w=x?10:P,A=x?1+2.5*m:1;g&&!N&&(L=!0),D=!1,z=!1,M.removeAll(),d.useSpeed(b?9:w).useMass(A),s.distance(f,!y),N=!1,v.emit("pointerUp")}function R(n){L&&n.preventDefault()}return{addActivationEvents:function(){var n=e;A.add(n,"touchmove",(function(){})).add(n,"touchend",(function(){})).add(n,"touchstart",C).add(n,"mousedown",C).add(n,"touchcancel",H).add(n,"contextmenu",H).add(n,"click",R)},clickAllowed:function(){return!L},pointerDown:function(){return z},removeAllEvents:function(){A.removeAll(),M.removeAll()}}}function h(n,t,e){var r,i,u=(r=2,i=Math.pow(10,r),function(n){return Math.round(n*i)/i}),c=g(0),a=g(0),f=g(0),s=0,d=t,l=e;function p(n){return d=n,m}function v(n){return l=n,m}var m={direction:function(){return s},seek:function(t){f.set(t).subtract(n);var e,r,i,u,p=(e=f.get(),(i=0)+(e-(r=0))/(100-r)*(d-i));return s=o(f.get()),f.normalize().multiply(p).subtract(c),(u=f).divide(l),a.add(u),m},settle:function(t){var e=t.get()-n.get(),r=!u(e);return r&&n.set(t),r},update:function(){c.add(a),n.add(c),a.multiply(0)},useBaseMass:function(){return v(e)},useBaseSpeed:function(){return p(t)},useMass:v,useSpeed:p};return m}function y(n,t,e,o,i){var u=i.measure(10),c=i.measure(50),a=!1;return{constrain:function(i){if(!a&&n.reachedAny(e.get())&&n.reachedAny(t.get())){var f=n.reachedMin(t.get())?"min":"max",s=r(n[f]-t.get()),d=e.get()-t.get(),l=Math.min(s/c,.85);e.subtract(d*l),!i&&r(d)<u&&(e.set(n.constrain(e.get())),o.useSpeed(10).useMass(3))}},toggleActive:function(n){a=!n}}}function S(n,t,e,r){var o=p(-t+n,e[0]),i=e.map(o.constrain);return{snapsContained:function(){if(t<=n)return[o.max];if("keepSnaps"===r)return i;var e=function(){var n=i[0],t=c(i),e=i.lastIndexOf(n),r=i.indexOf(t)+1;return p(e,r)}(),u=e.min,a=e.max;return i.slice(u,a)}()}}function b(n,t,e,r){var o=p(t.min+.1,t.max+.1),i=o.reachedMin,u=o.reachedMax;return{loop:function(t){if(function(n){return 1===n?u(e.get()):-1===n&&i(e.get())}(t)){var o=n*(-1*t);r.forEach((function(n){return n.add(o)}))}}}}function w(n){var t=n.max,e=n.length;return{get:function(n){return(n-t)/-e}}}function E(n,t,e,i,u){var c=i.reachedAny,a=i.removeOffset,f=i.constrain;function s(n){return n.concat().sort((function(n,t){return r(n)-r(t)}))[0]}function d(t,r){var i=[t,t+e,t-e];return n?s(r?i.filter((function(n){return o(n)===r})):i):i[0]}return{byDistance:function(e,o){var i=u.get()+e,s=function(e){var o=n?a(e):f(e);return{index:t.map((function(n){return n-o})).map((function(n){return d(n,0)})).map((function(n,t){return{diff:n,index:t}})).sort((function(n,t){return r(n.diff)-r(t.diff)}))[0].index,distance:o}}(i),l=s.index,p=s.distance,v=!n&&c(i);return!o||v?{index:l,distance:e}:{index:l,distance:e+d(t[l]-p,0)}},byIndex:function(n,e){return{index:n,distance:d(t[n]-u.get(),e)}},shortcut:d}}function A(n,t,e){var r="x"===n.scroll?function(n){return"translate3d(".concat(n,"px,0px,0px)")}:function(n){return"translate3d(0px,".concat(n,"px,0px)")},o=e.style,i=!1;return{clear:function(){i||(o.transform="",e.getAttribute("style")||e.removeAttribute("style"))},to:function(n){i||(o.transform=r(t.apply(n.get())))},toggleActive:function(n){i=!n}}}function M(n,t,e,r,o,i,c,a,f){var s,d=u(o),l=u(o).reverse(),p=(s=i[0]-1,x(m(l,s),"end")).concat(function(){var n=e-i[0]-1;return x(m(d,n),"start")}());function v(n,t){return n.reduce((function(n,t){return n-o[t]}),t)}function m(n,t){return n.reduce((function(n,e){return v(n,t)>0?n.concat([e]):n}),[])}function x(e,o){var i="start"===o,u=i?-r:r,s=c.findSlideBounds([u]);return e.map((function(e){var o=i?0:-r,u=i?r:0,c=s.filter((function(n){return n.index===e}))[0][i?"end":"start"],d=g(-1),l=g(-1),p=A(n,t,f[e]);return{index:e,location:l,translate:p,target:function(){return d.set(a.get()>c?o:u)}}}))}return{canLoop:function(){return p.every((function(n){var t=n.index;return v(d.filter((function(n){return n!==t})),e)<=.1}))},clear:function(){p.forEach((function(n){return n.translate.clear()}))},loop:function(){p.forEach((function(n){var t=n.target,e=n.translate,r=n.location,o=t();o.get()!==r.get()&&(0===o.get()?e.clear():e.to(o),r.set(o))}))},loopPoints:p}}function T(n,t,e,r,o,i,u){var c=o.removeOffset,a=o.constrain,f=i?[0,t,-t]:[0],s=d(f,u);function d(t,o){var i=t||f,u=function(n){var t=n||0;return e.map((function(n){return p(.5,n-.5).constrain(n*t)}))}(o);return i.reduce((function(t,o){var i=r.map((function(t,r){return{start:t-e[r]+u[r]+o,end:t+n-u[r]+o,index:r}}));return t.concat(i)}),[])}return{check:function(n,t){var e=i?c(n):a(n);return(t||s).reduce((function(n,t){var r=t.index,o=t.start,i=t.end;return!(-1!==n.indexOf(r))&&(o<e&&i>e)?n.concat([r]):n}),[])},findSlideBounds:d}}function O(t,e,r){var o=n(r);return{groupSlides:function(n){return o?function(n,t){return u(n).filter((function(n){return n%t==0})).map((function(e){return n.slice(e,e+t)}))}(n,r):function(n){return u(n).reduce((function(n,r){var o=e.slice(c(n),r+1).reduce((function(n,t){return n+t}),0);return!r||o>t?n.concat(r):n}),[]).map((function(t,e,r){return n.slice(t,r[e+1])}))}(n)}}}function B(n,t,e,o,i){var f=o.align,s=o.axis,d=o.direction,B=o.startIndex,P=o.inViewThreshold,k=o.loop,I=o.speed,z=o.dragFree,D=o.slidesToScroll,L=o.skipSnaps,N=o.containScroll,C=t.getBoundingClientRect(),V=e.map((function(n){return n.getBoundingClientRect()})),H=function(n){var t="rtl"===n?-1:1;return{apply:function(n){return n*t}}}(d),R=function(n,t){var e="y"===n?"y":"x";return{scroll:e,cross:"y"===n?"x":"y",startEdge:"y"===e?"top":"rtl"===t?"right":"left",endEdge:"y"===e?"bottom":"rtl"===t?"left":"right",measureSize:function(n){var t=n.width,r=n.height;return"x"===e?t:r}}}(s,d),j=R.measureSize(C),F=function(n){return{measure:function(t){return n*(t/100)}}}(j),q=l(f,j),U=!k&&""!==N,G=function(n,t,e,o,i){var u=n.measureSize,f=n.startEdge,s=n.endEdge,d=function(){if(!i)return 0;var n=e[0];return r(t[f]-n[f])}(),l=function(){if(!i)return 0;var n=window.getComputedStyle(c(o));return parseFloat(n.getPropertyValue("margin-".concat(s)))}(),p=e.map(u),v=e.map((function(n,t,e){var r=!t,o=t===a(e);return r?p[t]+d:o?p[t]+l:e[t+1][f]-n[f]})).map(r);return{slideSizes:p,slideSizesWithGaps:v}}(R,C,V,e,k||""!==N),J=G.slideSizes,W=G.slideSizesWithGaps,X=O(j,W,D),Y=function(n,t,e,o,i,u,f){var s,d=n.startEdge,l=n.endEdge,p=u.groupSlides,v=p(o).map((function(n){return c(n)[l]-n[0][d]})).map(r).map(t.measure),m=o.map((function(n){return e[d]-n[d]})).map((function(n){return-r(n)})),g=(s=c(m)-c(i),p(m).map((function(n){return n[0]})).map((function(n,t,e){var r=!t,o=t===a(e);return f&&r?0:f&&o?s:n+v[t]})));return{snaps:m,snapsAligned:g}}(R,q,C,V,W,X,U),K=Y.snaps,Q=Y.snapsAligned,Z=-c(K)+c(W),$=S(j,Z,Q,N).snapsContained,_=U?$:Q,nn=function(n,t,e){var r,o;return{limit:(r=t[0],o=c(t),p(e?r-n:o,r))}}(Z,_,k).limit,tn=v(a(_),B,k),en=tn.clone(),rn=u(e),on=function(n){var t=0;function e(n,e){return function(){n===!!t&&e()}}function r(){t=window.requestAnimationFrame(n)}return{proceed:e(!0,r),start:e(!1,r),stop:e(!0,(function(){window.cancelAnimationFrame(t),t=0}))}}((function(){k||vn.scrollBounds.constrain(vn.dragHandler.pointerDown()),vn.scrollBody.seek(an).update();var n=vn.scrollBody.settle(an);n&&!vn.dragHandler.pointerDown()&&(vn.animation.stop(),i.emit("settle")),n||i.emit("scroll"),k&&(vn.scrollLooper.loop(vn.scrollBody.direction()),vn.slideLooper.loop()),vn.translate.to(cn),vn.animation.proceed()})),un=_[tn.get()],cn=g(un),an=g(un),fn=h(cn,I,1),sn=E(k,_,Z,nn,an),dn=function(n,t,e,r,o,i){function u(r){var u=r.distance,c=r.index!==t.get();u&&(n.start(),o.add(u)),c&&(e.set(t.get()),t.set(r.index),i.emit("select"))}return{distance:function(n,t){u(r.byDistance(n,t))},index:function(n,e){var o=t.clone().set(n);u(r.byIndex(o.get(),e))}}}(on,tn,en,sn,an,i),ln=T(j,Z,J,K,nn,k,P),pn=x(R,H,n,an,function(n){var t,e;function o(n){return"undefined"!=typeof TouchEvent&&n instanceof TouchEvent}function i(n){return n.timeStamp}function u(t,e){var r=e||n.scroll,i="client".concat("x"===r?"X":"Y");return(o(t)?t.touches[0]:t)[i]}return{isTouchEvent:o,pointerDown:function(n){return t=n,e=n,u(n)},pointerMove:function(n){var r=u(n)-u(e),o=i(n)-i(t)>170;return e=n,o&&(t=n),r},pointerUp:function(n){if(!t||!e)return 0;var o=u(e)-u(t),c=i(n)-i(t),a=i(n)-i(e)>170,f=o/c;return c&&!a&&r(f)>.1?f:0},readPoint:u}}(R),cn,on,dn,fn,sn,tn,i,F,k,z,L),vn={containerRect:C,slideRects:V,animation:on,axis:R,direction:H,dragHandler:pn,eventStore:m(),percentOfView:F,index:tn,indexPrevious:en,limit:nn,location:cn,options:o,scrollBody:fn,scrollBounds:y(nn,cn,an,fn,F),scrollLooper:b(Z,nn,cn,[cn,an]),scrollProgress:w(nn),scrollSnaps:_,scrollTarget:sn,scrollTo:dn,slideLooper:M(R,H,j,Z,W,_,ln,cn,e),slidesToScroll:X,slidesInView:ln,slideIndexes:rn,target:an,translate:A(R,H,t)};return vn}var P={align:"center",axis:"x",containScroll:"",direction:"ltr",slidesToScroll:1,breakpoints:{},dragFree:!1,draggable:!0,inViewThreshold:0,loop:!1,skipSnaps:!1,speed:10,startIndex:0,active:!0};function k(){function n(n,t){return s(n,t||{})}return{merge:n,areEqual:function(n,t){return JSON.stringify(f(n.breakpoints||{}))===JSON.stringify(f(t.breakpoints||{}))&&d(n,t)},atMedia:function(t){var e=t.breakpoints||{},r=f(e).filter((function(n){return window.matchMedia(n).matches})).map((function(n){return e[n]})).reduce((function(t,e){return n(t,e)}),{});return n(t,r)}}}function I(n,t,e){var r,o,i,u,c,a=m(),f=k(),s=function(){var n=k(),t=n.atMedia,e=n.areEqual,r=[],o=[];function i(n){var r=t(n.options);return function(){return!e(r,t(n.options))}}var u={init:function(n,e){return o=n.map(i),(r=n.filter((function(n){return t(n.options).active}))).forEach((function(n){return n.init(e)})),n.reduce((function(n,t){var e;return Object.assign(n,((e={})[t.name]=t,e))}),{})},destroy:function(){r=r.filter((function(n){return n.destroy()}))},haveChanged:function(){return o.some((function(n){return n()}))}};return u}(),d=function(){var n={};function t(t){return n[t]||[]}var e={emit:function(n){return t(n).forEach((function(t){return t(n)})),e},off:function(r,o){return n[r]=t(r).filter((function(n){return n!==o})),e},on:function(r,o){return n[r]=t(r).concat([o]),e}};return e}(),l=d.on,p=d.off,v=w,g=!1,x=f.merge(P,I.globalOptions),h=f.merge(x),y=[],S=0;function b(t,e){if(!g){var a,l;if(a="container"in n&&n.container,l="slides"in n&&n.slides,i="root"in n?n.root:n,u=a||i.children[0],c=l||[].slice.call(u.children),x=f.merge(x,t),h=f.atMedia(x),r=B(i,u,c,h,d),S=r.axis.measureSize(i.getBoundingClientRect()),!h.active)return E();if(r.translate.to(r.location),y=e||y,o=s.init(y,O),h.loop){if(!r.slideLooper.canLoop())return E(),b({loop:!1},e);r.slideLooper.loop()}h.draggable&&u.offsetParent&&c.length&&r.dragHandler.addActivationEvents()}}function w(n,t){var e=T();E(),b(f.merge({startIndex:e},n),t),d.emit("reInit")}function E(){r.dragHandler.removeAllEvents(),r.animation.stop(),r.eventStore.removeAll(),r.translate.clear(),r.slideLooper.clear(),s.destroy()}function A(n){var t=r[n?"target":"location"].get(),e=h.loop?"removeOffset":"constrain";return r.slidesInView.check(r.limit[e](t))}function M(n,t,e){h.active&&!g&&(r.scrollBody.useBaseMass().useSpeed(t?100:h.speed),r.scrollTo.index(n,e||0))}function T(){return r.index.get()}var O={canScrollNext:function(){return r.index.clone().add(1).get()!==T()},canScrollPrev:function(){return r.index.clone().add(-1).get()!==T()},clickAllowed:function(){return r.dragHandler.clickAllowed()},containerNode:function(){return u},internalEngine:function(){return r},destroy:function(){g||(g=!0,a.removeAll(),E(),d.emit("destroy"))},off:p,on:l,plugins:function(){return o},previousScrollSnap:function(){return r.indexPrevious.get()},reInit:v,rootNode:function(){return i},scrollNext:function(n){M(r.index.clone().add(1).get(),!0===n,-1)},scrollPrev:function(n){M(r.index.clone().add(-1).get(),!0===n,1)},scrollProgress:function(){return r.scrollProgress.get(r.location.get())},scrollSnapList:function(){return r.scrollSnaps.map(r.scrollProgress.get)},scrollTo:M,selectedScrollSnap:T,slideNodes:function(){return c},slidesInView:A,slidesNotInView:function(n){var t=A(n);return r.slideIndexes.filter((function(n){return-1===t.indexOf(n)}))}};return b(t,e),a.add(window,"resize",(function(){var n=f.atMedia(x),t=!f.areEqual(n,h),e=r.axis.measureSize(i.getBoundingClientRect()),o=S!==e,u=s.haveChanged();(o||t||u)&&w(),d.emit("resize")})),setTimeout((function(){return d.emit("init")}),0),O}return I.globalOptions=void 0,I.optionsHandler=k,I}));


/***/ }),

/***/ 5094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ Accordion; }
/* harmony export */ });
/* harmony import */ var _var_www_bnkfinance_kz_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var _var_www_bnkfinance_kz_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1544);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3136);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8777);
/* harmony import */ var _shared_ui_Typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4006);
/* harmony import */ var public_static_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2576);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5893);


var _excluded = ["expandedId", "expanded", "setExpanded", "question", "answer", "className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_var_www_bnkfinance_kz_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








function Accordion(_ref) {
  var expandedId = _ref.expandedId,
      expanded = _ref.expanded,
      setExpanded = _ref.setExpanded,
      question = _ref.question,
      answer = _ref.answer,
      className = _ref.className,
      motionProps = (0,_var_www_bnkfinance_kz_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  var isOpen = expandedId === expanded;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(StyledAccordion, _objectSpread(_objectSpread({}, motionProps), {}, {
    className: className,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(StyledHeader, {
      initial: false,
      onClick: function onClick() {
        return setExpanded(isOpen ? false : expandedId);
      },
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_shared_ui_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .Z, {
        weight: 500,
        fontSize: "1.8rem",
        children: question
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        children: isOpen ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(public_static_icons__WEBPACK_IMPORTED_MODULE_3__/* .AccordionOpenedIcon */ .sI, {}) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(public_static_icons__WEBPACK_IMPORTED_MODULE_3__/* .AccordionCollapsedIcon */ .kJ, {})
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_6__/* .AnimatePresence */ .M, {
      initial: false,
      children: isOpen && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StyledContent, {
        initial: "collapsed",
        animate: "open",
        exit: "collapsed",
        variants: {
          open: {
            height: "auto",
            opacity: 1
          },
          collapsed: {
            height: 0,
            opacity: 0
          }
        },
        transition: {
          duration: 0.6,
          ease: [0.04, 0.62, 0.23, 0.98]
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StyledWrapper, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_shared_ui_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .Z, {
            tag: "div",
            dangerouslySetInnerHTML: {
              __html: answer
            }
          })
        })
      }, "content")
    })]
  }));
}
var StyledAccordion = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(framer_motion__WEBPACK_IMPORTED_MODULE_8__/* .motion.div */ .E.div).withConfig({
  displayName: "Accordion__StyledAccordion",
  componentId: "sc-14knbmw-0"
})(["background:", "26;box-shadow:", ";border-radius:0.4rem;"], function (props) {
  return props.theme.colors.primary_light_gray;
}, function (props) {
  return props.theme.shadow["30dp"];
});
var StyledHeader = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(framer_motion__WEBPACK_IMPORTED_MODULE_8__/* .motion.header */ .E.header).withConfig({
  displayName: "Accordion__StyledHeader",
  componentId: "sc-14knbmw-1"
})(["padding:2.4rem;display:grid;grid-template-columns:1fr auto;grid-gap:1.6rem;cursor:pointer;"]);
var StyledContent = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(framer_motion__WEBPACK_IMPORTED_MODULE_8__/* .motion.section */ .E.section).withConfig({
  displayName: "Accordion__StyledContent",
  componentId: "sc-14knbmw-2"
})(["overflow:hidden;"]);
var StyledWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(framer_motion__WEBPACK_IMPORTED_MODULE_8__/* .motion.div */ .E.div).withConfig({
  displayName: "Accordion__StyledWrapper",
  componentId: "sc-14knbmw-3"
})(["padding:0 2.4rem 2.4rem 2.4rem;max-width:77.5rem;"]);

/***/ }),

/***/ 7746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ Tabs; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8777);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);



function Tabs(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTabs, {
    className: props.className,
    children: props.tabs.map(function (item) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTab, {
        onClick: function onClick() {
          return props.setActiveTab(item.id);
        },
        isActive: item.id === props.activeTab,
        children: item.title
      }, item.id);
    })
  });
}
var StyledTabs = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Tabs__StyledTabs",
  componentId: "sc-7ebgwn-0"
})(["display:grid;grid-auto-flow:column;justify-content:flex-start;grid-gap:1.2rem;"]);
var StyledTab = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].button.withConfig */ .ZP.button.withConfig({
  displayName: "Tabs__StyledTab",
  componentId: "sc-7ebgwn-1"
})(["padding:0.8rem 1.2rem;border-radius:0.4rem;font-size:1.6rem;color:", ";border:1px solid ", ";background-color:", ";transition:all 0.3s ease;&:hover{color:", ";border-color:", ";}@media screen and (max-width:", "){padding:1.2rem;}"], function (_ref) {
  var isActive = _ref.isActive,
      theme = _ref.theme;
  return isActive ? theme.colors.basic_white : theme.colors.primary_light_gray;
}, function (_ref2) {
  var isActive = _ref2.isActive,
      theme = _ref2.theme;
  return isActive ? theme.colors.primary_red : theme.colors.primary_light_gray;
}, function (_ref3) {
  var isActive = _ref3.isActive,
      theme = _ref3.theme;
  return isActive ? theme.colors.primary_red : "none";
}, function (_ref4) {
  var isActive = _ref4.isActive,
      theme = _ref4.theme;
  return isActive ? theme.colors.basic_white : theme.colors.primary_red;
}, function (props) {
  return props.theme.colors.primary_red;
}, function (props) {
  return props.theme.sizes.tabletMin;
});

/***/ }),

/***/ 9493:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ ProductCategory; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(6835);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./shared/ui/Tabs/index.tsx
var Tabs = __webpack_require__(7746);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(29);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(7794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/embla-carousel-react/embla-carousel-react.umd.js
var embla_carousel_react_umd = __webpack_require__(9213);
var embla_carousel_react_umd_default = /*#__PURE__*/__webpack_require__.n(embla_carousel_react_umd);
// EXTERNAL MODULE: ./public/static/main/carousel/right-up.png
var right_up = __webpack_require__(440);
// EXTERNAL MODULE: ./public/static/main/carousel/right-bottom.png
var right_bottom = __webpack_require__(6785);
// EXTERNAL MODULE: ./shared/ui/Button/index.tsx
var Button = __webpack_require__(3794);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./shared/routes/index.ts
var routes = __webpack_require__(6329);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(8777);
// EXTERNAL MODULE: ./shared/ui/Typography/index.tsx
var Typography = __webpack_require__(4006);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 172 modules
var motion = __webpack_require__(3136);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./entities/Product/ProductLayout/ui/ProductLink/index.tsx





function ProductLink(_ref) {
  var title = _ref.title,
      selected = _ref.selected,
      className = _ref.className,
      setSelected = _ref.setSelected;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledTypography, {
    className: className,
    weight: 500,
    fontSize: "1.6rem",
    tag: "button",
    onClick: setSelected,
    children: [title, selected ? /*#__PURE__*/(0,jsx_runtime.jsx)(StyledUnderline, {
      layoutId: "products-underline"
    }) : null]
  });
}
var StyledTypography = (0,styled_components_browser_esm/* default */.ZP)(Typography/* Typography */.Z).withConfig({
  displayName: "ProductLink__StyledTypography",
  componentId: "sc-134ytjb-0"
})(["position:relative;cursor:pointer;display:grid;align-items:center;padding:2.4rem 1rem;&:hover{color:", ";}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.primary_red;
});
var StyledUnderline = (0,styled_components_browser_esm/* default */.ZP)(motion/* motion.div */.E.div).withConfig({
  displayName: "ProductLink__StyledUnderline",
  componentId: "sc-134ytjb-1"
})(["position:absolute;bottom:0;left:0;right:0;border-radius:1rem 1rem 0 0;height:2px;background:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.primary_red;
});
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./shared/ui/sharedstyles.tsx
var sharedstyles = __webpack_require__(8512);
;// CONCATENATED MODULE: ./entities/Product/ProductLayout/styled.ts





var View = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__View",
  componentId: "sc-3abt6g-0"
})([""]);
var Buttons = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__Buttons",
  componentId: "sc-3abt6g-1"
})(["display:grid;grid-auto-flow:column;justify-content:flex-start;grid-gap:1.8rem;opacity:0;pointer-events:none;position:absolute;bottom:4rem;right:3rem;@media screen and (max-width:", "){display:none;}"], function (props) {
  return props.theme.sizes.tablet;
});
var Empbla = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__Empbla",
  componentId: "sc-3abt6g-2"
})(["overflow:hidden;"]);
var EmpblaViewport = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__EmpblaViewport",
  componentId: "sc-3abt6g-3"
})(["position:relative;&:hover{", "{opacity:1;pointer-events:all;}}"], Buttons);
var EmpblaContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__EmpblaContainer",
  componentId: "sc-3abt6g-4"
})(["display:flex;"]);
var Slide = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__Slide",
  componentId: "sc-3abt6g-5"
})(["flex:0 0 100%;position:relative;aspect-ratio:16/5;overflow:hidden;@media screen and (max-width:", "){aspect-ratio:auto;height:calc(100vh - 5.6rem * 4);max-height:52rem;}"], function (props) {
  return props.theme.sizes.mobile;
});
var BackgroundImage = (0,styled_components_browser_esm/* default */.ZP)((image_default())).withConfig({
  displayName: "styled__BackgroundImage",
  componentId: "sc-3abt6g-6"
})(["width:100%;height:100%;object-fit:cover;filter:brightness(0.6);@media screen and (max-width:", "){max-width:initial;max-height:100%;object-position:55% 50%;}"], function (props) {
  return props.theme.sizes.mobile;
});
var RightImageContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__RightImageContainer",
  componentId: "sc-3abt6g-7"
})(["position:absolute;display:grid;grid-auto-flow:row;justify-content:flex-end;grid-template-rows:auto auto;top:0;right:0;bottom:0;height:100%;width:auto;@media screen and (max-width:", "){display:none;}"], function (props) {
  return props.theme.sizes.tablet;
});
var RightImageWrapper = (0,styled_components_browser_esm/* default */.ZP)(motion/* motion.div */.E.div).withConfig({
  displayName: "styled__RightImageWrapper",
  componentId: "sc-3abt6g-8"
})(["width:auto;height:100%;display:grid;justify-content:flex-end;"]);
var RightImage = (0,styled_components_browser_esm/* default */.ZP)((image_default())).withConfig({
  displayName: "styled__RightImage",
  componentId: "sc-3abt6g-9"
})(["width:auto;height:100%;"]);
var Promo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__Promo",
  componentId: "sc-3abt6g-10"
})(["position:absolute;top:0;bottom:0;left:0;right:0;z-index:1;"]);
var SContainer = (0,styled_components_browser_esm/* default */.ZP)(sharedstyles/* Container */.W).withConfig({
  displayName: "styled__SContainer",
  componentId: "sc-3abt6g-11"
})(["display:grid;align-content:center;justify-items:flex-start;height:100%;@media screen and (max-width:", "){text-align:center;justify-items:center;}"], function (props) {
  return props.theme.sizes.tablet;
});
var Title = (0,styled_components_browser_esm/* default */.ZP)(Typography/* Typography */.Z).withConfig({
  displayName: "styled__Title",
  componentId: "sc-3abt6g-12"
})(["margin-bottom:2.4rem;max-width:68.6rem;@media screen and (max-width:", "){margin-bottom:1.6rem;}"], function (props) {
  return props.theme.sizes.tablet;
});
var Subtitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* Typography */.Z).withConfig({
  displayName: "styled__Subtitle",
  componentId: "sc-3abt6g-13"
})(["margin-bottom:4rem;max-width:68.6rem;@media screen and (max-width:", "){margin-bottom:3.2rem;}"], function (props) {
  return props.theme.sizes.tablet;
});
var NavButtons = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__NavButtons",
  componentId: "sc-3abt6g-14"
})(["display:grid;grid-auto-flow:column;justify-content:center;grid-gap:6.4rem;box-shadow:", ";@media screen and (max-width:", "){grid-gap:4rem;padding-inline:1.6rem;overflow-x:auto;overflow-y:hidden;width:100%;}"], function (props) {
  return props.theme.shadow["10dp"];
}, function (props) {
  return props.theme.sizes.tablet;
});
var Children = (0,styled_components_browser_esm/* default */.ZP)(sharedstyles/* Container */.W).withConfig({
  displayName: "styled__Children",
  componentId: "sc-3abt6g-15"
})(["margin-top:6.4rem;"]);
/* harmony default export */ var styled = ({
  View: View,
  SContainer: SContainer,
  EmpblaContainer: EmpblaContainer,
  RightImageContainer: RightImageContainer,
  RightImage: RightImage,
  RightImageWrapper: RightImageWrapper,
  Subtitle: Subtitle,
  BackgroundImage: BackgroundImage,
  Title: Title,
  Slide: Slide,
  Promo: Promo,
  Empbla: Empbla,
  EmpblaViewport: EmpblaViewport,
  NavButtons: NavButtons,
  Children: Children
});
;// CONCATENATED MODULE: ./entities/Product/ProductLayout/index.tsx















function ProductLayout(props) {
  var _useEmblaCarousel = embla_carousel_react_umd_default()({
    skipSnaps: false,
    draggable: false
  }),
      _useEmblaCarousel2 = (0,slicedToArray/* default */.Z)(_useEmblaCarousel, 2),
      emblaRef = _useEmblaCarousel2[0],
      emblaApi = _useEmblaCarousel2[1];

  var router = (0,next_router.useRouter)();

  var _router$query$slug = (0,slicedToArray/* default */.Z)(router.query.slug, 2),
      category = _router$query$slug[0],
      productSlug = _router$query$slug[1];

  var selectedProduct = (0,react.useMemo)(function () {
    return props.products.find(function (product) {
      return product.slug === productSlug;
    });
  }, [productSlug]);

  var _useState = (0,react.useState)(selectedProduct.id),
      selectedProductId = _useState[0],
      setSelectedProductId = _useState[1];

  (0,react.useEffect)(function () {
    if (emblaApi) emblaApi.reInit();
  }, [props.products]);

  var selectProduct = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(id) {
      var selected;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              selected = props.products.find(function (product) {
                return product.id === id;
              });
              _context.next = 3;
              return router.push("/main/products/".concat(category, "/").concat(selected.slug, "/"), undefined, {
                scroll: false
              });

            case 3:
              setSelectedProductId(id);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function selectProduct(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var selectSlide = function selectSlide(productId, slideId) {
    selectProduct(productId);
    if (emblaApi) emblaApi.scrollTo(slideId);
  };

  (0,react.useEffect)(function () {
    setSelectedProductId(selectedProduct.id);
  }, [selectedProduct]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(styled.View, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(styled.Empbla, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(styled.EmpblaViewport, {
          ref: emblaRef,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styled.EmpblaContainer, {
            children: props.products.map(function (product) {
              return /*#__PURE__*/(0,jsx_runtime.jsxs)(styled.Slide, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styled.BackgroundImage, {
                  quality: 90,
                  priority: true,
                  width: "1080",
                  height: "720",
                  src: product.banner.url,
                  alt: product.banner.title
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(styled.Promo, {
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(styled.SContainer, {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styled.Title, {
                      initial: {
                        opacity: 0,
                        x: -50
                      },
                      whileInView: {
                        opacity: 1,
                        x: 0
                      },
                      transition: {
                        duration: 1
                      },
                      tag: "h2",
                      fontSize: "4.8rem",
                      weight: 700,
                      color: "basic_white",
                      children: product.banner.title
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(styled.Subtitle, {
                      initial: {
                        opacity: 0,
                        x: -50
                      },
                      whileInView: {
                        opacity: 1,
                        x: 0
                      },
                      transition: {
                        duration: 1,
                        delay: 0.3
                      },
                      fontSize: "2rem",
                      tag: "div",
                      color: "basic_white",
                      dangerouslySetInnerHTML: {
                        __html: product.banner.content
                      }
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                      href: {
                        pathname: routes/* routePaths.main.products.request */.X.main.products.request,
                        query: {
                          productId: product.id
                        }
                      },
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* Button */.z, {
                        initial: {
                          opacity: 0,
                          x: -50
                        },
                        whileInView: {
                          opacity: 1,
                          x: 0
                        },
                        transition: {
                          duration: 1,
                          delay: 0.6
                        },
                        children: product.banner.button_text
                      })
                    })]
                  })
                })]
              }, product.id);
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(styled.RightImageContainer, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styled.RightImageWrapper, {
              initial: {
                opacity: 0.8,
                y: -150
              },
              animate: {
                opacity: 0.8,
                y: 0
              },
              transition: {
                duration: 1
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(styled.RightImage, {
                src: right_up/* default */.Z,
                alt: "logo-top"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(styled.RightImageWrapper, {
              initial: {
                opacity: 0.8,
                y: 150
              },
              animate: {
                opacity: 0.8,
                y: 0
              },
              transition: {
                duration: 1
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(styled.RightImage, {
                src: right_bottom/* default */.Z,
                alt: "logo-bottom"
              })
            })]
          })]
        })
      })
    }), props.products.length > 1 && /*#__PURE__*/(0,jsx_runtime.jsx)(styled.NavButtons, {
      children: props.products.map(function (product, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(ProductLink, {
          title: product.name,
          selected: selectedProductId === product.id,
          setSelected: function setSelected() {
            return selectSlide(product.id, index);
          }
        }, product.id);
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(styled.Children, {
      children: props.children
    })]
  });
}
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./entities/Product/ProductBenefits/ui/ProductBenefit/index.tsx






var Icon = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 2185).then(__webpack_require__.bind(__webpack_require__, 2185));
}, {
  suspense: true,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(2185)];
    }
  }
});
function ProductBenefit(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      iconName = _ref.iconName;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledView, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledIconWrapper, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(react.Suspense, {
        fallback: "icon",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon, {
          name: iconName,
          iconColor: "primary_red",
          iconSize: 32
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledTitle, {
        tag: "h4",
        fontSize: "2.4rem",
        weight: 500,
        children: title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
        tag: "p",
        children: subtitle
      })]
    })]
  });
}
var StyledView = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ProductBenefit__StyledView",
  componentId: "sc-71asfb-0"
})(["display:grid;grid-gap:3.2rem;grid-auto-flow:column;align-items:flex-start;justify-content:flex-start;padding:2.4rem 0;@media screen and (max-width:", "){padding:0;grid-gap:2rem;}"], function (props) {
  return props.theme.sizes.tabletMin;
});
var StyledIconWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ProductBenefit__StyledIconWrapper",
  componentId: "sc-71asfb-1"
})(["width:6.4rem;height:6.4rem;display:flex;align-items:center;justify-content:center;border-radius:0 0.8rem;overflow:hidden;box-shadow:", ";"], function (props) {
  return props.theme.shadow["20dp"];
});
var StyledTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* Typography */.Z).withConfig({
  displayName: "ProductBenefit__StyledTitle",
  componentId: "sc-71asfb-2"
})(["margin-bottom:1.6rem;@media screen and (max-width:", "){font-size:2.4rem;}"], function (props) {
  return props.theme.sizes.tabletMin;
});
;// CONCATENATED MODULE: ./entities/Product/ProductBenefits/ui/index.ts

// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 14 modules
var esm = __webpack_require__(6720);
;// CONCATENATED MODULE: ./entities/Product/ProductBenefits/index.tsx








function ProductBenefits(_ref) {
  var benefits = _ref.benefits;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
    initial: {
      opacity: 0,
      y: -10
    },
    animate: {
      opacity: 1,
      y: 0
    },
    exit: {
      opacity: 0,
      y: 10
    },
    transition: {
      duration: 0.2
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ProductBenefits_StyledTitle, {
      tag: "h2",
      fontSize: "4rem",
      weight: 700,
      children: t("\u041F\u0440\u0435\u0438\u043C\u0443\u0449\u0435\u0441\u0442\u0432\u0430")
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledBenefits, {
      children: benefits.map(function (benefit) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(ProductBenefit, {
          title: benefit.title,
          subtitle: benefit.description,
          iconName: benefit.icon
        }, benefit.id);
      })
    })]
  });
}
var StyledBenefits = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ProductBenefits__StyledBenefits",
  componentId: "sc-osilxo-0"
})(["display:grid;grid-column-gap:3.2rem;grid-row-gap:2.4rem;grid-template-columns:1fr 1fr;@media screen and (max-width:", "){grid-template-columns:1fr;grid-gap:6.4rem;}"], function (props) {
  return props.theme.sizes.tabletMin;
});
var ProductBenefits_StyledTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* Typography */.Z).withConfig({
  displayName: "ProductBenefits__StyledTitle",
  componentId: "sc-osilxo-1"
})(["margin-bottom:4.3rem;@media screen and (max-width:", "){margin-bottom:4rem;}"], function (props) {
  return props.theme.sizes.tabletMin;
});
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./features/Calculator/index.tsx + 3 modules
var Calculator = __webpack_require__(1620);
;// CONCATENATED MODULE: ./entities/Product/ProductCalculator/index.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










function ProductCalculator(props) {
  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
    initial: {
      opacity: 0,
      y: -10
    },
    animate: {
      opacity: 1,
      y: 0
    },
    exit: {
      opacity: 0,
      y: 10
    },
    transition: {
      duration: 0.2
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ProductCalculator_StyledTitle, {
      tag: "h2",
      fontSize: "4rem",
      weight: 700,
      children: t("\u041A\u0430\u043B\u044C\u043A\u0443\u043B\u044F\u0442\u043E\u0440")
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Calculator/* Calculator */.y, _objectSpread(_objectSpread({}, props), {}, {
      href: routes/* routePaths.main.products.request */.X.main.products.request
    }))]
  });
}
var ProductCalculator_StyledTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* Typography */.Z).withConfig({
  displayName: "ProductCalculator__StyledTitle",
  componentId: "sc-w25ech-0"
})(["margin-bottom:1.8rem;@media screen and (max-width:", "){margin-bottom:2rem;}"], function (props) {
  return props.theme.sizes.tablet;
});
// EXTERNAL MODULE: ./shared/ui/Accordion/index.tsx
var Accordion = __webpack_require__(5094);
;// CONCATENATED MODULE: ./entities/Product/ProductFaq/index.tsx








function ProductFaq(props) {
  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var _useState = (0,react.useState)(0),
      expanded = _useState[0],
      setExpanded = _useState[1];

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
    initial: {
      opacity: 0,
      y: -10
    },
    animate: {
      opacity: 1,
      y: 0
    },
    exit: {
      opacity: 0,
      y: 10
    },
    transition: {
      duration: 0.2
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ProductFaq_StyledTitle, {
      tag: "h2",
      fontSize: "4rem",
      weight: 700,
      children: t("FAQ")
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledAccordions, {
      children: props.faqs.map(function (item) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Accordion/* Accordion */.U, {
          question: item.question,
          answer: item.answer,
          expandedId: item.id,
          expanded: expanded,
          setExpanded: setExpanded
        }, item.id);
      })
    })]
  });
}
var ProductFaq_StyledTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* Typography */.Z).withConfig({
  displayName: "ProductFaq__StyledTitle",
  componentId: "sc-1ro0pn5-0"
})(["margin-bottom:4rem;"]);
var StyledAccordions = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ProductFaq__StyledAccordions",
  componentId: "sc-1ro0pn5-1"
})(["display:grid;grid-auto-flow:row;grid-gap:0.8rem;"]);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 2 modules
var AnimatePresence = __webpack_require__(1544);
// EXTERNAL MODULE: ./features/Layout/index.tsx + 16 modules
var Layout = __webpack_require__(4999);
// EXTERNAL MODULE: ./shared/model/index.tsx
var model = __webpack_require__(9441);
;// CONCATENATED MODULE: ./src/pages/main/products/[...slug].tsx

















var __N_SSP = true;
function ProductCategory(props) {
  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var router = (0,next_router.useRouter)();

  var _router$query$slug = (0,slicedToArray/* default */.Z)(router.query.slug, 2),
      productSlug = _router$query$slug[1];

  var _useState = (0,react.useState)(0),
      activeTab = _useState[0],
      setActiveTab = _useState[1];

  var product = (0,react.useMemo)(function () {
    var currentProduct = props.categories.find(function (item) {
      return item.slug === productSlug;
    });
    (0,model/* setCurrentProductId */.PY)(currentProduct.id);
    return currentProduct;
  }, [productSlug, router.locale, props.categories]);
  var tabs = (0,react.useMemo)(function () {
    return [{
      id: 0,
      title: t("\u041F\u0440\u0435\u0438\u043C\u0443\u0449\u0435\u0441\u0442\u0432\u0430"),
      component: /*#__PURE__*/(0,jsx_runtime.jsx)(ProductBenefits, {
        benefits: product.benefits
      }, 0)
    }, {
      id: 1,
      title: t("\u041A\u0430\u043B\u044C\u043A\u0443\u043B\u044F\u0442\u043E\u0440"),
      component: /*#__PURE__*/(0,jsx_runtime.jsx)(ProductCalculator, {
        initSum: 1000000,
        minSum: 500000,
        maxSum: 58000000,
        stepSum: 50000,
        fromSum: t("\u043E\u0442 {{fromSum}} \u0442\u044B\u0441.", {
          fromSum: 500
        }),
        toSum: t("\u0434\u043E {{toSum}} \u043C\u043B\u043D.", {
          toSum: 58
        }),
        initTerm: 24,
        minTerm: 1,
        maxTerm: 84,
        stepTerm: 1,
        fromTerm: t("\u043E\u0442 {{fromTerm}} \u043C\u0435\u0441.", {
          fromTerm: 1
        }),
        toTerm: t("\u0434\u043E {{toTerm}} \u043B\u0435\u0442", {
          toTerm: 7
        }),
        href: product.banner.url,
        rate: product.loan_rate,
        productId: product.id
      }, 1)
    }, {
      id: 2,
      title: t("\u0412\u043E\u043F\u0440\u043E\u0441\u044B \u0438 \u043E\u0442\u0432\u0435\u0442\u044B"),
      component: /*#__PURE__*/(0,jsx_runtime.jsx)(ProductFaq, {
        faqs: product.faqs
      }, 2)
    }];
  }, [product, router.locale]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: t("\u0411\u041D\u041A \u0424\u0438\u043D\u0430\u043D\u0441 \u041A\u0430\u0437\u0430\u0445\u0441\u0442\u0430\u043D")
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(StyledDesktopContent, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Tabs/* Tabs */.m, {
          tabs: tabs,
          activeTab: activeTab,
          setActiveTab: setActiveTab
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledTabContent, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
            mode: "wait",
            children: tabs[activeTab].component
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledMobileContent, {
        children: tabs.map(function (tab) {
          return tab.component;
        })
      })]
    })]
  });
}

ProductCategory.getLayout = function getLayout(page) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* Layout */.A, {
    additionalButtonsVisible: true,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(ProductLayout, {
      products: page.props.categories,
      children: page
    })
  });
};

var StyledTabContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "slug__StyledTabContent",
  componentId: "sc-10gbdlm-0"
})(["padding-top:6.4rem;padding-bottom:8.4rem;"]);
var StyledDesktopContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "slug__StyledDesktopContent",
  componentId: "sc-10gbdlm-1"
})(["@media screen and (max-width:", "){display:none;}"], function (props) {
  return props.theme.sizes.tablet;
});
var StyledMobileContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "slug__StyledMobileContent",
  componentId: "sc-10gbdlm-2"
})(["display:none;@media screen and (max-width:", "){display:grid;grid-gap:6.4rem;padding-bottom:6.4rem;}"], function (props) {
  return props.theme.sizes.tablet;
});

/***/ }),

/***/ 7977:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/main/products/[...slug]",
      function () {
        return __webpack_require__(9493);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8359,1664,5675,2151,1358,7802,301,4999,5761,9774,2888,179], function() { return __webpack_exec__(7977); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);